import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import css from './StripeCheckout.module.css';
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = loadStripe(stripePublishableKey);
const StripeCheckout = props => {
  const { secret } = props;
  const fetchClientSecret = () => {
    return secret;
  };
  const options = {
    fetchClientSecret,
  };
  if (!secret) {
    return null;
  }
  return (
    <div id="checkout" className={css.pageRoot}>
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default StripeCheckout;
